import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  AUTHORITIES
} from "../../../constants/constants";
import axiosInstance from "../../../api/utils/axiosInstance";
import { BASE_URL } from "../../../constants/constants";

function loginRequest() {
  return {
    type: LOGIN_REQUEST,
    isPending: true,
  };
}

function loginSuccess(payload) {
  return {
    type: LOGIN_SUCCESS,
    isPending: false,
    isAuthenticated: true,
    payload,
  };
}

function loginFailed() {
  return {
    type: LOGIN_FAILURE,
    isPending: false,
    isAuthenticated: false,
    error: true,
  };
}
function authorities(payload) {
  return {
    type: AUTHORITIES,
    payload,
  };
};

export const userLogin = (redirect) => (dispatch) => {
  dispatch(loginRequest());

  return axiosInstance
    .get(`${BASE_URL}/user-data/tid/`)
    .then((response) => {
      window.sessionStorage.clear();

      dispatch(loginSuccess(response.data));
        //dohvat authorities-a 
        axiosInstance.get(`${BASE_URL}/user-data/authorities`)
        .then((res) => { 
          dispatch(authorities(res.data))});

      return { userData: response.data };
    })
    .catch((err) => {
      dispatch(loginFailed());
      redirect();

      throw err;
    });
};
